<template>
  <div>
    <b-row align-h="end">
      <b-col cols="12" class="mb-1">
        <h1 class="mb-4">Choisissez votre agence <strong>{{$root.slugData.name}}</strong></h1>
      </b-col>
      <b-col cols="12" md="4" class="my-auto">
        <b-form-select
          v-on:change="$emit('update', $event)"
          :options="selectOptions"
          v-model="selectedOption"
        ></b-form-select>
      </b-col>
      <b-col cols="12" md="8" class="mt-4 mt-md-0">
        <Map v-on:update="$emit('update', $event)" :offices="offices" v-on:hovering="updateSelect"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Map from "./Map.vue";

export default {
  name: "OfficeChoice",

  components: {
    Map,
  },

  data() {
    return {
      offices: this.$root.slugData.offices,
      selectOptions: [{
        value: null,
        text: "Choisissez une agence"
      }],
      selectedOption: null
    };
  },

  mounted() {
    this.offices.forEach((e) => {
      this.selectOptions.push({
        value: e,
        text: e.name,
      });
    });
  },

  methods: {
    updateSelect(value) {
      this.selectedOption = value;
    }
  },
};
</script>
<style lang="scss">
.svg-map {
  width: 100%;
  height: auto;
}
</style>
